// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__d4_V2","validationTips":"StatementDescriptor_validationTips__1JVaW"};